import React, { useEffect, useState } from "react";
import { func, bool, object, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import Headline from "../../atoms/Headline";
import ProfileHeadline from "../../atoms/ProfileHeadline";
import More from "../../atoms/More";

import { setLoading, setHomeComments } from "../../helper/actions";
import { getUserComments } from "../../helper/api";
import { processComments, getBanglaDate, getEngDate } from "../../utils/utils";

import "./user-comments.m.css";

const UserComments = ({ setLoading, isLoading, setHomeComments, publisherAttributes, jwtToken, metypeConfig }) => {
  const [page, setPage] = useState(1);
  const [comments, setComments] = useState([]);
  const [noMoreStories, setNoMoreStories] = useState(false);

  useEffect(() => {
    jwtToken && getComments();
  }, [jwtToken]);

  const getComments = () => {
    setLoading(true);

    getUserComments(metypeConfig, jwtToken, page)
      .then((data) => {
        // If length is 0 then set to true indicating no more stories
        if (!data.length) {
          setNoMoreStories(true);
        } else {
          const processedComments = processComments(data);

          if (page === 1) {
            // Store the first 4 comments in store so that it can be used on comments popup in header
            setHomeComments(processedComments.slice(0, 4));
          }

          setPage(page + 1);
          setComments([...comments, ...processedComments]); // Merge old and new comments list
        }
      })
      .finally(() => setLoading(false));
  };

  const MoreComponent = (
    <div styleName={`load-more-view ${publisherAttributes.lang}-load-more-view `}>
      <More type="load-more" text="Load More" onClick={getComments} />
    </div>
  );

  const noCommentsView = () => (
    <div styleName="no-comments-wrapper">
      <div styleName="comments-here-msg">
        <span>Your comments will show here.</span>
      </div>
      <Link href="/" styleName="exploring-link">
        START EXPLORING
      </Link>
    </div>
  );

  return (
    <div styleName={`container ${publisherAttributes.lang}-container`}>
      <ProfileHeadline title="My Comments" lang={publisherAttributes.lang} />

      {comments.map((item, index) => {
        const dateObj = new Date(item.createdAt);
        return (
          <div key={index} styleName="comment-wrapper">
            <Link href={item.url} target="_blank" rel="noopener noreferrer">
              <Headline text={item.headline || ""} headlineType={6} headerLevel={2} />
            </Link>
            <div styleName="content">
              <Link href={item.url} target="_blank" rel="noopener noreferrer">
                <p styleName="comments">
                  {item.comments.map((element, elementIndex) => {
                    if (element.isMentioned) {
                      return (
                        <span key={elementIndex} styleName="user-bold">
                          @{element.link}&nbsp;
                        </span>
                      );
                    }

                    return <span key={elementIndex}>{element.message}&nbsp;</span>;
                  })}
                </p>
                <time styleName="comment-at">
                  {publisherAttributes.lang === "en"
                    ? getEngDate(dateObj.getTime(), "monthname")
                    : getBanglaDate(dateObj.getTime())}
                </time>
                <span styleName="view-discussion">View discussion</span>
              </Link>
            </div>
          </div>
        );
      })}

      {!comments.length && !isLoading && noCommentsView()}

      {!noMoreStories && !isLoading && comments.length === 20 && MoreComponent}
    </div>
  );
};

UserComments.propTypes = {
  setLoading: func,
  setHomeComments: func,
  isLoading: bool,
  metypeConfig: object,
  jwtToken: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  isLoading: get(state, ["pageLoading"], false),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
  setHomeComments: (list) => dispatch(setHomeComments(list)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserComments);
